export const FILTER_TYPE_COURSES = 1;
export const FILTER_TYPE_EVENTS = 2;
